'use client';

import { ReactNode } from 'react';

import { Container } from '@bytel/trilogy-react-ts';

export default function CustomContainer({ children }: Readonly<{ children: ReactNode }>) {
    return <Container className='home-container ac mWAppX2'>{children}</Container>;
}
